import React from 'react';
import { motion } from 'framer-motion';
import { Award, Users, TrendingUp } from 'lucide-react';
import { BrandName } from './BrandName';
export function About() {
  return <section id="about" className="py-20 bg-sum-light" data-id="element-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-7">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-8">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mb-12 lg:mb-0" data-id="element-9">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-10">
              <img src="https://cdn.magicpatterns.com/uploads/qEytsX3C5R2wHMJajBkWs8/sales_up_image_pic.png" alt="Split screen of two men in offices talking on the phone while working on computers" className="w-full h-auto object-cover rounded-2xl" data-id="element-11" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-sum-charcoal to-transparent p-8" data-id="element-12">
                <p className="text-white font-bold text-xl" data-id="element-13">
                  <BrandName data-id="element-14" /> Marketing
                </p>
                <p className="text-gray-200" data-id="element-15">Your partner in growth</p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-extrabold text-sum-charcoal mb-6" data-id="element-17">
              8 Years of Hands-On Experience
            </h2>

            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-18">
              Hi, I'm the founder of <BrandName data-id="element-19" /> Marketing. I believe that
              getting your business online shouldn't be complicated or
              stressful.
            </p>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed font-medium text-sum-green" data-id="element-20">
              "Every project is tailored—I work closely with you to bring your
              vision to life."
            </p>

            <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-21">
              Starting a business is tough. We know the frustration that comes
              with navigating all the challenges. But you don't have to do it
              alone. We're here to guide you every step of the way, providing
              personalized support and creative thinking to help your vision
              become reality.
            </p>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-22">
              We work with you, hand-in-hand, to turn your ideas into action.
              Whether you're stuck on design, messaging, or strategy, we break
              it down step-by-step. Trust in us to help you build something
              amazing.
            </p>

            <div className="space-y-6" data-id="element-23">
              <div className="flex" data-id="element-24">
                <div className="flex-shrink-0" data-id="element-25">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-green-100 text-sum-green" data-id="element-26">
                    <TrendingUp size={24} data-id="element-27" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-28">
                  <h3 className="text-xl font-bold text-sum-charcoal" data-id="element-29">
                    Real Results
                  </h3>
                  <p className="mt-2 text-base text-gray-600" data-id="element-30">
                    Helping businesses grow their online presence and boost
                    sales through strategic SEO and engaging content.
                  </p>
                </div>
              </div>

              <div className="flex" data-id="element-31">
                <div className="flex-shrink-0" data-id="element-32">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-yellow-100 text-sum-gold" data-id="element-33">
                    <Users size={24} data-id="element-34" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-35">
                  <h3 className="text-xl font-bold text-sum-charcoal" data-id="element-36">
                    Personal Touch
                  </h3>
                  <p className="mt-2 text-base text-gray-600" data-id="element-37">
                    You deal directly with me. No passing you off to junior
                    staff or confusing you with tech talk.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}